import axios from "axios";
import React, { useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import AuditionApproveFilterVideo from "../../../../AuditionAdmin/AuditonRounds/AuditionApproveFilterVideo";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import ReUseableSingleRoundTab from "../../../../Reuseable/ReUseableSingleRoundTab";
import "./StarAuditionRoundVideoMarking.css";
import StarMarkTable from "./StarMarkTable";

const StarAuditionRoundVideoMarking = (props) => {
  const audition_id = props.match.params.audition_id;
  const [activeRound, setActiveRound] = React.useState(0);
  const [roundInfo, setRoundInfo] = useState([]);
  const [audition, setAudition] = React.useState({});
  const [auditionRounds, setAuditionRounds] = React.useState({});
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState({});
  const [allMarkedVideo, setAllMarkedVideo] = useState([]);
  const [mark, setMark] = useState("");
  const [comment, setComment] = useState("");

  const fetchAuditionData = () => {
    setLoading(true);
    axios.get(`/api/superstar/audition/details/${audition_id}`).then((res) => {
      if (res.data.status === 200) {
        setAudition(res.data.audition);
        setActiveRound(res.data.audition.active_round_info_id);
        setRoundInfo(res.data.audition.active_round_info);
        setAuditionRounds(res.data?.audition?.audition_round);
      }
      setLoading(false);
    });
  };
  const fetchRoundVideos = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/superstar/audition/videos/${activeRound}`).then((res) => {
        if (res.data.status === 200) {
          setVideos(res.data.videos);
          setAllMarkedVideo(res.data.selectedVideos);
        }
      });
    });
  };

  const handleSelectedVideo = (event) => {
    setSelectedVideo(event);
  };

  useEffect(() => {
    fetchAuditionData();
  }, [audition_id]);

  useEffect(() => {
    fetchRoundVideos();
  }, [activeRound]);


  const approvalWithMarkHandler = () => {
    setLoader(true);
    if (
      selectedVideo.id === "" ||
      selectedVideo.id < 1 ||
      selectedVideo.id === undefined
    ) {
      swal("Warning", "Please Select a video first", "warning");
    } else if (mark === "" || mark < 1 || mark > 100) {
      swal("Warning", "Mark  Required & Should not more then 0", "warning");
    } else {
      const fData = new FormData();

      fData.append("audition_uploads_video_id", selectedVideo?.id);
      fData.append("audition_id", audition_id);
      fData.append("round_info_id", activeRound);
      fData.append("judge_mark", mark);
      fData.append("judge_comment", comment);

      axios.post(`/api/star/audition/video/marking`, fData).then((res) => {
        setLoader(false);
        if (res.data.status === 200) {
          setMark("");
          setComment("");
          fetchRoundVideos();
        }
      });
    }
  };

  const authName = localStorage.getItem("auth_name");

  const joinCall = (room_id) => {
    // setCallJoinBuffer(true)
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/get-token/admin`).then((res) => {
          // setCallJoinBuffer(false)
          // setToken(res.data.token);

          window.open(
            `/video-meeting?token=${res.data.token}&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
          );
        });
      })
      .catch((err) => {
        alert("network problem");
      });
  };

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {auditionRounds &&
                      auditionRounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>
        </>
      )}
      {roundInfo?.round_type === 1 ? (
        <div className="text-center">
          <button
            className="btn btnCreate fw-bold"
            onClick={() => joinCall(roundInfo?.room_id)}
          >
            Join Now
          </button>
        </div>
      ) : null}
      {console.log('roundInfo?.round_type',roundInfo?.round_type)}

      <div className="row m-3">
        <div className="card card-bg head-line ">
          <h4
            style={{ color: "rgb(253 224 71)" }}
            className="mx-3 fw-bolder text-center p-2"
          >
            All User Videos
          </h4>
        </div>

        <div className="my-3">
          <AuditionApproveFilterVideo
            data={videos}
            selectedVideo={selectedVideo}
            handleSelectedVideo={handleSelectedVideo}
          />
        </div>

        <div className="py-4 row justify-content-center">
          <div className="col-sm-12 col-md-3 col-lg-2 mb-3">
            <h5 className="text-light">
              Mark: <span className="mx-2">100</span>
            </h5>
            <input
              type="number"
              className="form-control reply-control"
              placeholder="Enter Mark"
              value={mark}
              onChange={(e) => setMark(e.target.value)}
            />
          </div>
          <div className="col-sm-12 col-md-3 col-lg-2 mb-3">
            <h5 className="text-light">Comment:</h5>
            <input
              type="text"
              className="form-control reply-control"
              placeholder="Write Comment...."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
          <div className="roundBtnCursor col-sm-12 col-md-3 col-lg-2 mb-3 pt-4">
            <button
              type="button"
              className="btn fw-bold w-100 btnConfirm px-3 mt-2"
              onClick={approvalWithMarkHandler}
            >
              {loader ? <i className="fas fa-spinner fa-pulse"></i> : <></>}
              &nbsp;Submit
            </button>
          </div>
        </div>

        <>
          {allMarkedVideo.length === 0 ? null : (
            <>
              <div className="under-line"></div>

              <div className="card card-bg head-line m-2 mt-3">
                <div className="text-light">
                  <h4
                    style={{ color: "rgb(253 224 71)" }}
                    className="mx-3 fw-bolder text-center p-2"
                  >
                    Marked Videos ({allMarkedVideo && allMarkedVideo.length})
                  </h4>
                </div>
              </div>

              <div className="my-3">
                <StarMarkTable data={allMarkedVideo} />
              </div>
            </>
          )}
        </>
      </div>
    </>
  );
};

export default StarAuditionRoundVideoMarking;
